//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import qs from 'qs'
import Window from '../utils/Window'

let timer = null
export default {
  name: 'm-pay',
  data () {
    return {
      countdownTimer: 1800,
      orderCode: '',
      productName: '',
      holderName: '',
      holderIdNumber: '',
      holderPhone: '',
      bankName: '',
      bankNumber: '',
      agreeTerms: true,
      ticketDialog: false,
      productBackMoney: 0,
      backMoney: 0,
      couponsName: '',
      actualPrice: 0,
      thisPrice: 0,
      bankCode: [],
      insuranceCode: '',
      holderPhoneCAPTCHA: '',
      CAPTCHACountdown: 0,
      mainOrderCode: '',
      Window: Window,
      mydata: '',
      code: this.getQueryString('code'),
      openId: '',
      currentURL: '',
      paybest: 10000,
      nextSend: false,
      currentProductIndexURL: '',
      commonResultURL: ''
    }
  },
  created () {
    this.currentProductIndexURL = window.location.pathname + '#/' + this.$store.state.app.innerCode + '/' + this.$store.state.app.productCode + '?' + qs.stringify(this.$route.query)
    this.commonResultURL = '/products/' + this.$store.state.app.productCode + '/result?' + (this.h5 ? 'merchantCode' : 'innerCode') + '=' + this.$store.state.app.innerCode + '&unionCode=' + this.$store.state.order.unionCode + '&indexURL=' + encodeURIComponent(this.currentProductIndexURL)

    const data = {}
    if (this.$route.query.activityCode) {
      data.activityCode = this.$route.query.activityCode
    }
    let orderQuerenURL = '/api/hqdqx/orderQueren/'
    if (this.h5) {
      orderQuerenURL = '/api/channel/hqdqx/orderQueren/'
    }
    this.$http.get(orderQuerenURL + this.$store.state.app.innerCode + '/' + this.$store.state.app.productCode + '/' + this.$store.state.order.unionCode + '?' + qs.stringify(data)).then(response => {
      this.orderCode = response.data.busOrder.orderCode
      this.productName = response.data.busProductRelation.productName
      this.holderName = response.data.underwritingInfoList[0].policyHolder.holderName
      this.holderIdNumber = response.data.underwritingInfoList[0].policyHolder.holderIdNumber
      this.holderPhone = response.data.underwritingInfoList[0].policyHolder.holderPhone
      this.actualPrice = response.data.underwritingInfoList[0].actualPrice / 100
      this.backMoney = response.data.backMoney
      this.productBackMoney = response.data.productBackMoney
      this.thisPrice = response.data.underwritingInfoList[0].premium / 100
      this.couponsName = response.data.couponsName
      // 百年产品线上流程倒计时为当天24:00,改变线下核保倒计时的开始时间
      if (this.isAeonlife()) {
        if (window.sessionStorage.getItem('isoffline') !== 'offline') {
          const today = new Date()
          const todayY = today.getFullYear()
          const todayM = today.getMonth()
          const todayD = today.getDate()
          let thisDayTime = new Date(todayY, todayM, todayD + 1)
          this.countdownTimer = Math.floor((thisDayTime.getTime() - Date.now()) / 1000)
          timer = setInterval(() => {
            if (this.countdownTimer <= 0) {
              clearInterval(timer)
            }
            this.countdownTimer--
          }, 1000)
        }
      } else {
        const passSeconds = Math.floor((Date.now() - response.data.orderCreateDate) / 1000)
        this.countdownTimer = this.countdownTimer - passSeconds
        this.countdownTimer = this.countdownTimer < 0 ? 0 : this.countdownTimer
        timer = setInterval(() => {
          if (this.countdownTimer <= 0) {
            clearInterval(timer)
          }
          this.countdownTimer--
        }, 1000)
      }
      this.insuranceCode = response.data.underwritingInfoList[0].insuranceCode
    })
  },
  mounted () {
    document.title = '支付详情'
    this.$http.get('https://m.wkbins.com/explosions/static/common/js/tongji.txt?where=pay&productCode=' + this.$store.state.app.productCode + '&innerCode=' + this.$store.state.app.innerCode + '&utm_source=' + (this.$route.query.utm_source || '')).then(response => {
    })
  },
  destroyed () {
  },
  computed: {
    isAeonlifeUnderwriting () {
      return window.sessionStorage.getItem('fit') === 'false' && this.isAeonlife() && window.sessionStorage.getItem('isoffline') === 'offline'
    },
    h5 () {
      return this.$store.state.app.h5
    },
    banks () {
      /**
       * 这里有一个小技巧
       * 视图中用到了banks，所以会赋值两次，第一次没有值，第二次有值
       * 等第二次有值之后，再判断是否有banks
       */
      if (this.$store.state.config.pay) {
        if (this.$store.state.config.banksFromServer.length > 0) {
          return this.$store.state.config.banksFromServer
        } else if (this.$store.state.config.pay.banks) {
          return this.$store.state.config.pay.banks
        }
        this.$http.get('/api/mild/getPolicyInfoByUnionOrderCode?unionOrderCode=' + this.$store.state.order.unionCode).then(response => {
          if (response.data.result !== 'success') return
          this.bankName = response.data.data.bankName
          this.bankNumber = response.data.data.underwritingInfo.cardNumber
          this.mainOrderCode = response.data.data.mainOrderCode
        })
      }
    },
    rawBanks () {
      if (this.$store.state.config.rawBanksFromServer) {
        return this.$store.state.config.rawBanksFromServer
      }
    },
    agreement () {
      if (this.$store.state.config.pay) {
        return this.$store.state.config.pay.agreement
      }
    },
    CAPTCHALabel () {
      if (this.CAPTCHACountdown === 0) {
        return '获取'
      }
      return this.CAPTCHACountdown + '秒'
    },
    paymentUnit () {
      if (this.$store.state.order.paymentMode === 1) {
        return '年'
      } else if (this.$store.state.order.paymentMode === 2) {
        return '月'
      }
      return this.$store.state.config.paymentUnit
    }
  },
  methods: {
    isWXPayProducts () {
      return ['150476691002746473', '150537492578996275', '150831059068987214', '150840325766681140', '151013300258317638', '151072428587363110', '150634119420883220', '150631164164706555'].indexOf(this.$store.state.app.productCode) !== -1
    },
    submitPay () {
      if (this.banks) {
        if (this.bankCode.length === 0) {
          this.$vux.toast.show({
            type: 'text',
            text: '客官，请选择银行',
            position: 'top',
            width: '20em'
          })
          return
        }
        if (this.bankNumber.length === 0) {
          this.$vux.toast.show({
            type: 'text',
            text: '客官，请输入银行卡号',
            position: 'top',
            width: '20em'
          })
          return
        }
        // 银行卡号必须在15-19位中间
        if (!(this.bankNumber.length > 14 && this.bankNumber.length < 20)) {
          this.$vux.toast.show({
            type: 'text',
            text: '客官，请正确输入银行卡号',
            position: 'top',
            width: '20em'
          })
          return
        }
      } else {
        if (!this.checkHolderPhoneCAPTCHA()) return
      }
      if (!this.agreeTerms) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请您认真阅读理解并同意相关声明后再试',
          position: 'top',
          width: '20em'
        })
        return
      }
      if (this.countdownTimer <= 0 && !this.isAeonlifeUnderwriting) {
        const that = this
        this.$vux.confirm.show({
          confirmText: '重新下单',
          title: '订单逾期',
          content: '订单逾期，请重新下单！',
          onConfirm () {
            that.$router.push({name: that.$store.state.config.policy.path || 'Form', params: {productCode: that.$store.state.app.productCode, innerCode: that.$store.state.app.innerCode}, query: that.$route.query})
          }
        })
        return
      }
      if (!this.isAeonlifeUnderwriting) {
        this.$vux.loading.show({
          text: '正在支付'
        })
      }
      const data = {
        orderCode: this.orderCode,
        innerCode: this.$store.state.order.innerCode,
        bankCode: this.bankCode[0],
        hengqinBankCode: this.bankCode[0],
        bankCardNum: this.bankNumber,
        CAPTCHA: this.holderPhoneCAPTCHA,
        mainOrderCode: this.mainOrderCode
      }
      if (this.$route.query.activityCode) {
        data.activityCode = this.$route.query.activityCode
      }
      if (this.nextSend) {
        return
      }
      this.nextSend = true
      if (this.isAeonlifeUnderwriting) {
        const _this = this
        _this.$vux.alert.show({
          title: '支付授权声明',
          content: '<div style="max-height: 300px; overflow-y: auto; text-align: left; line-height: 1.5rem;"><p style="background: #f6f6f6;padding: .5rem;box-sizing: border-box;color: #ff7124;line-height: 1.2rem;font-size: .875rem;">提交支付后，我们不会立即扣款，首期保险费在保险公司收到投保申请并同意承保后扣除</p>投保人（以下简称本人）对百年人寿保险股份有限公司（以下简称百年人寿）及授权的开户银行（以下简称银行）授权如下：<br>1、本人同意委托百年人寿，从本人的授权账户中扣取本保险合同所需缴纳的保险费，并保证授权账户中有足够的金额支付应交保险费。<br>2、本人确认授权的银行账户所有人为投保人本人账户的开户银行、户名和账号均真实有效，续期交费账户与首期保费交纳账户为同一账户。<br>3、本人同意若因账户挂失、账户冻结、账户余额不足或其他非银行原因造成转账不成功，致使产生保险合同终止的任何后果或投资账户的费用损失，因此引起的责任概由本人承担。<br>4、如本人在同一指定账户内同时授权两张或两张以上保险单中的保险费或其他自动转账业务时，本人同意依照百年人寿规定的转账顺序转账。<br>5、本人投保后若办理退保或退费业务，同意百年人寿将应退金额通过银行划转入该账户。<br>6、本人因故结清账户，会重新开立账户，并及时通过百年人寿进行变更。如本人欲终止本授权，应立即向百年人寿递交终止的书面申请，由百年人寿知会银行停止转账；若因本人未及时办理账户变更手续而导致退保给付金无法按时给付，则同意百年人寿按退保申请日的给付金额支付。<br>7、本人同意百年人寿于保险合同成立后30日内进行首期保险费的划转；对于一年期以上的产品，百年人寿可在保险费约定支付日之前及时通知本人交纳续期保险费。</div>',
          buttonText: '我同意以上声明',
          onShow () {
          },
          onHide () {
            // 点击弹框的时候请求支付新接口
            _this.$vux.loading.show({
              text: '正在提交支付'
            })
            const paydata = {}
            const paydataLast = {
              bankCode: _this.bankCode[0],
              bankCardNum: _this.bankNumber
            }
            paydata.unionOrderCode = _this.$store.state.order.unionCode
            paydata.innerCode = _this.$store.state.app.innerCode
            _this.$http.post('/api/pay/payAuthorize/' + paydata.unionOrderCode + '/' + paydata.innerCode, qs.stringify(paydataLast)).then((response) => {
              _this.$vux.loading.hide()
              console.log(response)
              _this.nextSend = false
              if (response.data === true) {
                if (_this.$store.state.config.feedback) {
                  _this.$store.state.config.feedback.status
                    ? _this.$router.push({name: 'Feedback', params: {productCode: _this.$store.state.app.productCode, innerCode: _this.$store.state.app.innerCode, unionCode: _this.$store.state.order.unionCode}, query: _this.$route.query})
                    : _this.$router.push({name: 'Resultfit', params: {productCode: _this.$store.state.app.productCode, innerCode: _this.$store.state.app.innerCode, unionCode: _this.$store.state.order.unionCode}, query: _this.$route.query})
                }
              } else {
                _this.$vux.toast.show({
                  type: 'text',
                  text: response.data.slice(6),
                  position: 'top',
                  width: '20em'
                })
                return false
              }
            })
          }
        })
      } else {
        let path = 'pay'
        if (this.insuranceCode === 'guohuaqingzhengxian') path = 'mild'
        const payURL = '/api/' + path + '/baofooPayWithholdFresh/' + this.$store.state.order.unionCode + '/' + this.$store.state.app.innerCode
        if (this.isWXPayProducts() && this.payWithWX()) {
          if (this.isWX()) {
            this.$wechat.miniProgram.getEnv((res) => {
              if (!res.miniprogram) { // 小程序
                data.payWay = 1
              }
              // 支付
              this.baofooPay(payURL, data)
            })
          } else {
            data.payWay = 12
            // 支付
            this.baofooPay(payURL, data)
          }
        } else {
          // 支付
          this.baofooPay(payURL, data)
        }
      }
    },
    payWithWX () {
      const price = this.actualPrice || this.thisPrice
      // const price = 50000000 // 测试超出限额是否调用微信支付
      for (let i = 0; i < this.rawBanks.length; i++) {
        console.log(price, this.rawBanks[i].bankSingleQuota / 100)
        if (this.rawBanks[i].bankCode === this.bankCode[0] && price > (this.rawBanks[i].bankSingleQuota / 100)) {
          // alert('条件成立')
          return true
        }
      }
      return false
    },
    checkHolderPhoneCAPTCHA () {
      if (this.holderPhoneCAPTCHA === '') {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请输入验证码',
          position: 'top',
          width: '20em'
        })
        return false
      }
      if (!/^\d{4}$/.test(this.holderPhoneCAPTCHA)) {
        this.$vux.toast.show({
          type: 'text',
          text: '客官，请正确输入验证码',
          position: 'top',
          width: '20em'
        })
        return false
      }
      return true
    },
    sendCAPTCHA () {
      const that = this
      const utmSourcePhone = 'wechat170913'
      const random = Math.random()
      const needBusParam = this.holderPhone + '?utm_source_phone=' + utmSourcePhone + '&v=' + random
      let sendMessageCode = '/api/common/sendMessageCodeNew/' + this.holderPhone + '?v=' + random + '&serviceName=' + window.hex_md5(needBusParam)
      this.$http.get(sendMessageCode)
        .then(response => {
          if (response.data.statusCode === '000000') {
            that.CAPTCHACountdown = 60
            const CAPTCHATimer = setInterval(() => {
              if (that.CAPTCHACountdown === 0) {
                clearInterval(CAPTCHATimer)
              } else {
                that.CAPTCHACountdown--
              }
            }, 1000)
          } else {
            this.$vux.toast.show({
              type: 'text',
              text: response.data.statusMsg,
              position: 'top',
              width: '20em'
            })
          }
        })
    },
    showTicketDialog () {
      this.ticketDialog = true
    },
    payimmediately () {
      // $.ajax({
      //   type: 'POST',
      //   url: '/wxpay/payImmediately',
      //   data: {orderCode: '11'},
      //   success: function (result) {
      //     if (result === 'false') {
      //       return
      //     } else {
      //       // onBridgeReady(eval('['+result+']')[0])
      //     }
      //   }
      // })
    },
    onBridgeReady () {
      // wx.chooseWXPay({
      //   appId:'${wechatJsModel.appId}',
      //     timestamp: resultdata.h5PayReqData.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
      //     nonceStr: resultdata.h5PayReqData.nonceStr, // 支付签名随机串，不长于 32 位
      //     "package": resultdata.h5PayReqData.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
      //     signType: resultdata.h5PayReqData.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
      //     paySign: resultdata.h5PayReqData.paySign, // 支付签名
      //     success: function (res) {
      //       // if (null !== $('#backUrl').val() && ""!=$("#backUrl").val()){
      //       //   window.location = "${ctxPath}" + $("#backUrl").val()
      //       // } else {
      //       //   window.location = '${ctxPath}/weChat/personalCenter'
      //       // }
      //     },
      //     error: function (res) {
      //       alert('h5 request error:' + JSON.stringify(res))
      //     },
      //     cancel: function (res) {
      //       console.log('cancel')
      //     }
      // })
    },
    getQueryString (name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      let r = window.location.search.substr(1).match(reg)
      if (r != null) return unescape(r[2])
      return null
    },
    delUrlParam (url, ref) {
      // 如果不包括此参数
      if (url.indexOf(ref) === -1) return url
      var arrUrl = url.split('?')
      var base = arrUrl[0]
      var arrParam = arrUrl[1].split('&')
      var index = -1
      for (let i = 0; i < arrParam.length; i++) {
        var paired = arrParam[i].split('=')
        if (paired[0] === ref) {
          index = i
          break
        }
      }
      if (index === -1) {
        return url
      } else {
        arrParam.splice(index, 1)
        return base + '?' + arrParam.join('&')
      }
    },
    isWX () {
      return window.navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
    },
    isAeonlife () {
      if (['150476691002746473', '150537492578996275', '150570517523511386', '150546537968917914'].indexOf(this.$store.state.app.productCode) !== -1) {
        return true
      }
      return false
    },
    baofooPay (payURL, data) {
      this.$http.post(payURL, qs.stringify(data)).then(response => {
        this.$vux.loading.hide()
        this.nextSend = false
        if (response.data === 302) { // 跳转到微信
          // 校验银行卡号
          this.$http.get('/api/pay/bankcard/check?' + 'bankCode=' + this.bankCode[0] + '&bankCardNum=' + this.bankNumber + '&unionOrderCode=' + this.$store.state.order.unionCode).then(response => {
            const _this = this
            let resultdata = response.data
            if (resultdata.code === 'false') {
              // _this.$vux.toast.show({
              //   type: 'text',
              //   text: resultdata.msg,
              //   position: 'top',
              //   width: '20em'
              // })
              _this.$vux.confirm.show({
                title: '提示',
                content: '<p style="text-align: left; line-height: 1.5rem; margin-top: .5rem;">' + resultdata.msg + '</p>',
                confirmText: '咨询客服',
                cancelText: '取消',
                onCancel () {
                },
                onConfirm () {
                  window.location.href = 'tel:400-661-2992'
                }
              })
            } else {
              if (this.$store.state.config.feedback) {
                this.$store.state.config.feedback.status ? window.location.href = '/common/wxpay?order=' + _this.$store.state.order.unionCode + '&redirect_uri=' + encodeURIComponent(window.location.href.replace('pay', 'feedback')) + '&pay_uri=' + encodeURIComponent(window.location.href) : window.location.href = '/common/wxpay?order=' + _this.$store.state.order.unionCode + '&redirect_uri=' + encodeURIComponent(_this.commonResultURL) + '&pay_uri=' + encodeURIComponent(window.location.href)
              } else {
                window.location.href = '/common/wxpay?order=' + _this.$store.state.order.unionCode + '&redirect_uri=' + encodeURIComponent(_this.commonResultURL) + '&pay_uri=' + encodeURIComponent(window.location.href)
              }
            }
          })
          return false
        }
        if (response.data !== true) {
          // this.$vux.toast.show({
          //   type: 'text',
          //   text: response.data.substring(6),
          //   position: 'top',
          //   width: '20em'
          // })
          this.$vux.confirm.show({
            title: '提示',
            content: '<p style="text-align: left; line-height: 1.5rem; margin-top: .5rem;">' + response.data.substring(6) + '</p>',
            confirmText: '咨询客服',
            cancelText: '取消',
            onCancel () {
            },
            onConfirm () {
              window.location.href = 'tel:400-661-2992'
            }
          })
          return false
        }
        if (this.$store.state.config.feedback) {
          this.$store.state.config.feedback.status
            ? this.$router.push({name: 'Feedback', params: {productCode: this.$store.state.app.productCode, innerCode: this.$store.state.app.innerCode, unionCode: this.$store.state.order.unionCode}, query: this.$route.query})
            // : this.$router.push({name: 'Result', params: {productCode: this.$store.state.app.productCode, innerCode: this.$store.state.app.innerCode, unionCode: this.$store.state.order.unionCode}, query: this.$route.query})
            : (window.location.href = this.commonResultURL)
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Pay.vue